import axios from 'axios';

const api = axios.create({
  baseURL: 'https://main.victriedemos.com:3023/api',
  withCredentials: true
});

export default api;
